import React from 'react';
import Icon, { GLYPHS } from '../../../common/icon';

const MembershipPaymentWarning = () => (
  <div className="c-payment-type-warning-item">
    <Icon glyph={GLYPHS.exclamationCircle} size="small" />
    <span className="u-pl-">Memberships require a card on file for future payments</span>
  </div>
);

export default MembershipPaymentWarning;
